import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// modules
import User from './modules/_user.module';
import Auth from './modules/auth.module';
import Home from './modules/home/home.module';
import Trips from '@/store/modules/trips/trips';
import Trip from '@/store/modules/trips/trip';
import DialogTrip from '@/store/modules/trips/dialogTrip';
import feedback from '@/store/modules/feedback/feedback';
import Filter from './modules/filter/filter.module';
import ListContainer from './modules/list-container/list-container.module';
import Invoices from './modules/invoices/invoices.module';
import CustomerInvoices from "@/store/modules/accounting/customerInvoices/customerInvoices";
import Safety from './modules/safety/safety.module';
import cities from './modules/maintance/cities/cities';
import users from '@/store/modules/maintance/users/users';
import Brokers from './modules/maintance/brokers/brokers';
import AccountingSettings from './modules/settings/accounting/accounting.module';
import AccountSettings from './modules/settings/accountSettings/accountSettings';
import UserAccountSettingsTabSchedule from './modules/settings/userAccountSettings/tabSchedule';
import UserAccountSettingsTabHolidays from './modules/settings/userAccountSettings/tabHolidays';
import UserAccountSettingsTabOffice from './modules/settings/userAccountSettings/tabOffice';
import UserAccountSettingsTabInventory from './modules/settings/userAccountSettings/tabInventory';
import UserAccountSettingsTabNotifications from './modules/settings/userAccountSettings/tabNotifications';
import UserAccountSettingsTabContactsTypes from './modules/settings/userAccountSettings/tabContactsTypes';
import UserAccountSettingsTabDocumentsTypes from './modules/settings/userAccountSettings/tabDocumentsTypes';
import UserAccountSettingsTabCompanies from './modules/settings/userAccountSettings/tabCompanies';
import UserAccountSettingsTabDepartments from './modules/settings/userAccountSettings/tabDepartments';
import UserAccountSettingsTabPositions from './modules/settings/userAccountSettings/tabPositions';
import UserAccountSettingsTabVersions from './modules/settings/userAccountSettings/tabVersions';
import Preloader from './modules/preloader/preloader.module';
import Roles from './modules/roles/roles';
import SystemSettings from './modules/settings/system-settings/system-settings.module';
import MapModule from './modules/google-map/google-map.module';
import reportsOld from "@/store/modules/reportsOld/reportsOld";
import reports from "@/store/modules/statistics/reports/reports";
import safetyCalendar from "@/store/modules/safetyCalendar/safetyCalendar";
import schedules from "@/store/modules/accounting/schedules/schedules";
import billing from '@/store/modules/accounting/billing/billing.module';
import shortPayments from '@/store/modules/accounting/shortPayments/shortPayments';
import CustomerPayments from '@/store/modules/accounting/customer-payments/customer-payments.module';
import Customers from '@/store/modules/maintance/customer/customer';
import drivers from '@/store/modules/maintance/drivers/drivers';
import employee from "@/store/modules/maintance/employee/employee";
import Maintenance from '@/store/modules/maintance/maintenance';
import workOrders from "@/store/modules/workOrders/workOrders";
import workOrdersStatistics from "@/store/modules/workOrders/workOrdersStatistics";
import customerInvoiceItems from "@/store/modules/accounting/customerInvoiceItems/customerInvoiceItems";
import dispatcherStatements from "@/store/modules/accounting/dispatchers-statements/dispatcher-statements.module";
import safetyStatements from "@/store/modules/accounting/safetyStatements/safetyStatements";
import factoring from "@/store/modules/safety/factoring.module";
import logbooks from "@/store/modules/safety/logbooks/logbooks";
import exception from "@/store/modules/safety/logbooks/exception";
import dispatcherStatementCreateForm
from "@/store/modules/accounting/dispatchers-statements/dispatcher-statement-create-form/dispatcher-statement-create-form.module";
import Trailers from "@/store/modules/maintance/trailers/trailers";
import TrailersEquipment from "@/store/modules/maintance/trailers/trailersEquipment";
import TrailersNotes from "@/store/modules/maintance/trailers/trailersNotes";
import TrailerValue from "@/store/modules/maintance/trailers/trailerValue";
import TruckValue from "@/store/modules/maintance/trucks/truckValue";
import Trucks from "@/store/modules/maintance/trucks/trucks";
import truckEquipment from "@/store/modules/maintance/trucks/truckEquipment";
import truckNotes from "@/store/modules/maintance/trucks/truckNotes";
import trucksRoad from "@/store/modules/fleet/trucksRoad/trucksRoad";
import motivationProgram from "@/store/modules/workOrders/motivationProgram";
import systemSettings from "@/store/modules/settings/systemSettings/systemSettings";
import planer from "@/store/modules/fleet/planer/planer";
import calendar from "@/store/modules/accounting/calendar/calendar";
import driverStatements from "@/store/modules/accounting/driverStatements/driverStatements";
import fuel from "@/store/modules/accounting/fuel/fuel";
import profile from "@/store/modules/profile/profile";
import AccountTabGeo from "@/store/modules/account/AccountTabGeo";
import profileTabMyInformation from "@/store/modules/profile/tabMyInformation";
import account from "@/store/modules/account/account";
import tabCalendarEvents from "@/store/modules/account/tabCalendarEvents";

import potentialClients from "@/store/modules/maintance/potentialClients/potentialClients";
import clients from "@/store/modules/maintance/clients/clients";
import employeeWorkSchedule from "@/store/modules/safety/employeeWorkSchedule/employeeWorkSchedule";
import bonusCharge from "@/store/modules/accounting/bonusCharge/bonusCharge";
import settings from "@/store/modules/shared/settings";
import exportFile from "@/store/modules/shared/exportFile";
import accountDayChat from "@/store/modules/shared/accountDayChat";
import dispatchStatistics from "@/store/modules/statistics/dispatchStatistics/dispatchStatistics";
import preview from "@/store/modules/preview/preview";
import managerStatements from "@/store/modules/safety/managerStatements/managerStatements";
import UserProfile from "@/store/modules/user-profile/userProfile";
import activeFilters from "@/store/modules/activeFilters/activeFilters";
import lostPayment from "@/store/modules/accounting/lostPayment/lostPayment";
import safetyStatistic from "@/store/modules/statistics/safetyStatistic/safetyStatistic";
import logbooksMod from "@/store/modules/safety/logbooksMod/logbooksMod";
import incomeTransactions from "@/store/modules/accounting/incomeTransactions/incomeTransactions";
const modules = {
	AccountTabGeo,
	Preloader,
	account,
	profile,
	profileTabMyInformation,
	User,
	Auth,
	Home,
	Trips,
	Trip,
	DialogTrip,
	Filter,
	ListContainer,
	Invoices,
	CustomerInvoices,
	Safety,
	cities,
	users,
	AccountingSettings,
	AccountSettings,
	UserAccountSettingsTabSchedule,
	UserAccountSettingsTabHolidays,
	UserAccountSettingsTabOffice,
	UserAccountSettingsTabInventory,
	UserAccountSettingsTabNotifications,
	UserAccountSettingsTabContactsTypes,
	UserAccountSettingsTabDocumentsTypes,
	UserAccountSettingsTabCompanies,
	UserAccountSettingsTabDepartments,
	UserAccountSettingsTabPositions,
	UserAccountSettingsTabVersions,
	Roles,
	SystemSettings,
	Brokers,
	MapModule,
	reportsOld,
	reports,
	safetyCalendar,
	schedules,
	billing,
	shortPayments,
	CustomerPayments,
	Customers,
	drivers,
	employee,
	Maintenance,
	workOrders,
	workOrdersStatistics,
	motivationProgram,
	customerInvoiceItems,
	dispatcherStatements,
	safetyStatements,
	factoring,
	logbooks,
	exception,
	Trailers,
	TrailersEquipment,
	TrailersNotes,
	TrailerValue,
	TruckValue,
	Trucks,
	truckEquipment,
	truckNotes,
	dispatcherStatementCreateForm,
	trucksRoad,
	systemSettings,
	calendar,
	planer,
	driverStatements,
	fuel,
	potentialClients,
	clients,
	feedback,
	employeeWorkSchedule,
	bonusCharge,
	settings,
	exportFile,
	accountDayChat,
	dispatchStatistics,
	preview,
	managerStatements,
	UserProfile,
	tabCalendarEvents,
	activeFilters,
	lostPayment,
	safetyStatistic,
	logbooksMod,
	incomeTransactions,
};

export default new Vuex.Store({ modules });
